<template>
    <div>
        <div class="layout-popup-contents">
            <div class="step-container">
                <p v-if="isCopy">{{$t('POLICY.RULE.POPUP.DESC.RULE_COPY_DESC')}}</p>
                <p v-if="isEdit">{{$t('POLICY.RULE.POPUP.DESC.RULE_EDIT_DESC')}}</p>
                <p v-if="!isCopy && !isEdit">{{$t('POLICY.RULE.POPUP.DESC.RULE_CREA_DESC')}}</p>

                <ol class="step">
                    <li value="1" v-bind:class="{'current' : curStep === 1, 'done' : curStep === 2}">{{$t('POLICY.RULE.POPUP.STEP1')}}</li>
                    <li value="2" v-bind:class="{'current' : curStep === 2}">{{$t('POLICY.RULE.POPUP.STEP2')}}</li>
                </ol>
            </div>
            <div v-if="curStep === 1" class="scroll-container" :key="rule.ruleId">
                <fieldset class="forms">
                    <legend>{{$t('POLICY.BUTTON.ADD_RULE')}}</legend>
                    <div class="vstack">
                        <!-- 규칙 이름 -->
                        <!--FOR EN-->
                        <div class="form-item">
                            <label for="r_name" class="textfield-with">{{$t('POLICY.RULE.TITLE')}} in English<span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <input ref="input_title" type="text" id="r_name" :placeholder="$t('POLICY.RULE.PLACEHOLDER.TITLE')"
                                class="text-field"
                                style="width: 600px;"
                                :data-invalid="invalidRuleTitle"
                                v-model="rule.enRuleTitle"
                                @input="rule.enRuleTitle = $event.target.value; isInvalidRuleTitle();"
                                @focusout="isInvalidRuleTitle()">
                                    <p class="invalid-message" v-if="invalidRuleTitle">
                                        {{invalidRuleTitleMsg}}
                                    </p>
                        </div>
                        <!--FOR KO-->
                        <div class="form-item">
                            <label for="r_name" class="textfield-with">{{$t('POLICY.RULE.TITLE')}} in Korean <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <input ref="input_title" type="text" id="r_name" :placeholder="$t('POLICY.RULE.PLACEHOLDER.TITLE')"
                                class="text-field"
                                style="width: 600px;"
                                :data-invalid="invalidRuleTitle"
                                v-model="rule.koRuleTitle"
                                @input="rule.koRuleTitle = $event.target.value; isInvalidRuleTitle();"
                                @focusout="isInvalidRuleTitle()">
                                    <p class="invalid-message" v-if="invalidRuleTitle">
                                        {{invalidRuleTitleMsg}}
                                    </p>
                        </div>
                        <!--FOR ZH-->
                        <div class="form-item">
                            <label for="r_name" class="textfield-with">{{$t('POLICY.RULE.TITLE')}} in China<span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <input ref="input_title" type="text" id="r_name" :placeholder="$t('POLICY.RULE.PLACEHOLDER.TITLE')"
                                class="text-field"
                                style="width: 600px;"
                                :data-invalid="invalidRuleTitle"
                                v-model="rule.zhRuleTitle"
                                @input="rule.zhRuleTitle = $event.target.value; isInvalidRuleTitle();"
                                @focusout="isInvalidRuleTitle()">
                                    <p class="invalid-message" v-if="invalidRuleTitle">
                                        {{invalidRuleTitleMsg}}
                                    </p>
                        </div>

                        <!-- 설명 -->
                        <!--FOR EN-->
                        <div class="form-item">
                            <label for="r_desc" class="textfield-with">{{$t('LABEL.DESCRIPTION')}} in English</label>
                            <textarea name="" id="r_desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"
                                      :invalid="invalidRuleDesc ? true : null"
                                      v-model="rule.enRuleDesc"
                                      @input="rule.enRuleDesc = $event.target.value; isInvalidRuleDesc();"
                                      @focusout="isInvalidRuleDesc()"></textarea>
                            <p class="invalid-message" v-if="invalidRuleDesc">{{$t('SETTING.WHITELIST.ERROR.MAX', {'cnt' :'4000'})}}</p>
                        </div>
                         <!--FOR KO-->
                        <div class="form-item">
                            <label for="r_desc" class="textfield-with">{{$t('LABEL.DESCRIPTION')}} in Korean</label>
                            <textarea name="" id="r_desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"
                                      :invalid="invalidRuleDesc ? true : null"
                                      v-model="rule.koRuleDesc"
                                      @input="rule.koRuleDesc = $event.target.value; isInvalidRuleDesc();"
                                      @focusout="isInvalidRuleDesc()"></textarea>
                            <p class="invalid-message" v-if="invalidRuleDesc">{{$t('SETTING.WHITELIST.ERROR.MAX', {'cnt' :'4000'})}}</p>
                        </div>
                         <!--FOR ZH-->
                        <div class="form-item">
                            <label for="r_desc" class="textfield-with">{{$t('LABEL.DESCRIPTION')}} in China</label>
                            <textarea name="" id="r_desc" class="textarea" :placeholder="$t('POLICY.RULE.PLACEHOLDER.DESC')"
                                      :invalid="invalidRuleDesc ? true : null"
                                      v-model="rule.zhRuleDesc"
                                      @input="rule.zhRuleDesc = $event.target.value; isInvalidRuleDesc();"
                                      @focusout="isInvalidRuleDesc()"></textarea>
                            <p class="invalid-message" v-if="invalidRuleDesc">{{$t('SETTING.WHITELIST.ERROR.MAX', {'cnt' :'4000'})}}</p>
                        </div>

                        <!-- 카테고리 레이블 -->
                        <div class="form-item popout-layer">
                            <label for="" class="textfield-with">{{$t('POLICY.RULE.CATEGORY_LABEL')}} <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>

                            <select-box-multi select-id="rule-select-ctg"
                                select-class="type-tagging"
                                place-holder="FILTER.SELECT_CATEGORY_PLEASE"
                                :use-labels="true"
                                :use-translate="true"
                                :select-box-options="getCtgFilterOptions"
                                :select-box-value="rule.ctgLabel"
                                :data-invalid="invalidRuleCtgLabel"
                                @onSelectChange="rule.ctgLabel = $event.value; isInvalidRuleCategoryLabel()"></select-box-multi>
                            <p class="invalid-message" v-if="invalidRuleCtgLabel">{{$t('POLICY.RULE.INVALID.CATEGORY_LABEL')}}</p>
                        </div>

                        <div class="form-item popout-layer">
                            <label for="" class="textfield-with">{{$t('LABEL.SEVERITY')}} <span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <select-box-single select-id="select_svrty"
                                select-class="type-single"
                                :use-translate="true"
                                :select-box-options="svrtyOptions"
                                :select-box-value="rule.svrty"
                                @onSelectChange="rule.svrty = $event.value"></select-box-single>
                        </div>
                    </div>
                </fieldset>

            </div>

            <div v-else-if="curStep === 2" class="scroll-container">

                <fieldset class="forms">
                    <legend>{{$t('POLICY.BUTTON.ADD_RULE')}}</legend>

                    <div class="vstack">
                        <div class="form-item">
                            <!--DESCRIBE THE FOLLOWINGS INCLUDE PRODUCT, ETC BY ENG, KOR AND ZH-->
                            <label for="" class="textfield-with">{{$t('POLICY.RULE.POPUP.STEP2_DESC')}}<span class="icon-required">{{$t('COMMON.FIELD_REQUIRE')}}</span></label>
                            <div class="add-rule-conditions">
                                <div v-for="(cnd, cndIdx) in rule.cndVal" :key="cnd.tmpltId + cndIdx + reRenderKey">
                                    <!-- select connect conjuntion : and / or -->
                                    <div class="select-connect" v-if="cnd.cjt !== null">
                                        <select-box-single :select-id="`select_conjunction_${cndIdx}`"
                                            select-class="type-single size-s"
                                            :select-box-options="conjunctionOptions"
                                            :select-box-value="cnd.cjt"
                                            :data-invalid="invalidRuleCtgLabel"
                                            :use-translate="true"
                                            @onSelectChange="cnd.cjt = $event.value"></select-box-single>
                                    </div>

                                    <div class="select-detail-condition">
                                        <div class="actions" v-if="cnd.tmpltId != 'new' || (cnd.tmpltId === 'new' && cndIdx > 0)">
                                            <button type="button" class="buttons-icon" data-type="ghost" data-icon="delete" data-size="s" :title=" $t('COMMON.BUTTON.CAMEL.DELETE')" @click="delCnd(cndIdx)">{{$t('COMMON.BUTTON.CAMEL.DELETE')}}</button>
                                        </div>
                                        <!-- select condition -->
                                        <div class="conditions" v-if="cnd.tmpltId === 'new'">
                                            <!-- Product Filter -->
                                            <select-box-single :select-id="`elProdFltr_${cndIdx}`"
                                                select-class="search type-single size-s"
                                                :select-box-options="getprodFlterOptions"
                                                place-holder="POLICY.RULE.POPUP.SELECT_PRODUCT"
                                                :select-box-value="prodDynamicVal"
                                                :use-translate="true"
                                                @onSelectChange="prodDynamicInvalid = false;cndDynamicInvalid = false; msrFilterOptions = $event.value"
                                                :data-invalid="prodDynamicInvalid"
                                            ></select-box-single>

                                            <!-- Measure Filter -->
                                            <select-box-single :select-id="`elMsrFltr_${cndIdx}`"
                                                :select-box-value="msrDynamicVal"
                                                select-class="search type-single size-s"
                                                select-value="msr"
                                                select-text="msr"
                                                before-text="MEASURE."
                                                :use-translate="true"
                                                :use-dynamic="true"
                                                :dynamic-value="prodDynamicVal"
                                                :select-box-options="msrFilterOptions"
                                                place-holder="POLICY.RULE.POPUP.SELECT_MEASURE"
                                                @onSelectChange="cndDynamicInvalid = false; msrDynamicVal = $event.value"
                                            ></select-box-single>

                                            <!-- Condition Filter -->
                                            <select-box-single v-if="msrDynamicVal !== ''"
                                                :select-id="`elCndFltr_${cndIdx}_1`"
                                                select-class="search type-single size-s"
                                                select-value="tmpltId"
                                                select-text="tmpltId"
                                                before-text="TEMPLATE."
                                                :use-translate="true"
                                                :use-dynamic="true"
                                                :dynamic-value="msrDynamicVal"
                                                :data-invalid="cndDynamicInvalid"
                                                :select-box-options="cndFilterMsrOptions"
                                                place-holder="POLICY.RULE.POPUP.SELECT_CONDITION"
                                                @onSelectChange="cndDynamicInvalid = false; selectTemplate($event)"></select-box-single>
                                            <select-box-single v-else :select-id="`elCndFltr_${cndIdx}_2`"
                                                select-class="search type-single size-s"
                                                select-value="tmpltId"
                                                select-text="tmpltId"
                                                before-text="TEMPLATE."
                                                :use-translate="true"
                                                :use-dynamic="true"
                                                :dynamic-value="prodDynamicVal"
                                                :select-box-options="cndFilterOptions"
                                                place-holder="POLICY.RULE.POPUP.SELECT_CONDITION"
                                                :data-invalid="cndDynamicInvalid"
                                                @onSelectChange="cndDynamicInvalid = false; selectTemplate($event)"></select-box-single>

                                            <p v-if="prodDynamicInvalid || cndDynamicInvalid" class="invalid-message">
                                                {{ $t('POLICY.RULE.INVALID.TEMPLATE_prod')}}
                                            </p>
                                        </div>
                                        <!-- select detail -->
                                        <div class="conditions" v-else-if="cnd.tmpltId != 'new'">
                                            <div class="row">
                                                <template v-for="(lang, index) in newTmplt[cndIdx][curLang].lang" >
                                                    <template v-if="lang['key'] === 'text'">
                                                        <span :key="index">{{ lang['val'] }}</span>
                                                    </template>

                                                    <template v-if="lang['key'] === 'input'">
                                                        <input-box :init-value="cnd.cnd.prpts[lang['val']].val"
                                                                :key="index"
                                                                @onInputChange="cnd.cnd.prpts[lang['val']].val = $event.value;cnd.cnd.prpts[lang['val']].invalid = false"
                                                                :data-invalid="cnd.cnd.prpts[lang['val']].invalid">

                                                        </input-box>
                                                    </template>

                                                    <template v-if="lang['key'] === 'input-select'">
                                                        <input-box :init-value="cnd.cnd.prpts[lang['val']].val"
                                                            :key="index"
                                                            @onInputChange="cnd.cnd.prpts[lang['val']].val = $event.value;cnd.cnd.prpts[lang['val']].invalid = false"
                                                            :data-invalid="cnd.cnd.prpts[lang['val']].invalid">

                                                        </input-box>

                                                        <select-box-single :select-id="`cndInputSelect_${cndIdx}_${index}`"
                                                            :key="index"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt[0]"
                                                            select-class="type-single search size-s"
                                                            use-translate="true"
                                                            before-text="BASIC_FORMATION_UNIT."
                                                            select-text="key"
                                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]"></select-box-single>
                                                    </template>

                                                    <!-- type, view 아닌 select. 그냥 표시해주면 됨. -->
                                                   <template v-if="lang['key'] === 'select'
                                                                     && lang['val'] != 'type'
                                                                     && lang['val'] != 'view'
                                                                     && lang['val'] != 'svcGrp'
                                                                     && lang['val'] != 'cfg'
                                                                     && lang['val'] != 'rsrc'">
                                                        <select-box-single
                                                            :select-id="`cndSelect_${cndIdx}_${index}`"
                                                            :key="index"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt[0]"
                                                            select-class="type-single search size-s"
                                                            use-translate="true"
                                                            before-text="BASIC_FORMATION_UNIT."
                                                            :data-invalid="cnd.cnd.prpts[lang['val']].invalid"
                                                            select-text="key"
                                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]"></select-box-single>
                                                    </template>

                                                    <template v-if="lang['key'] === 'select' && lang['val'] === 'cfg'">
                                                        <select-box-single
                                                            :select-id="`cndSelectCfg_${cndIdx}_${index}`"
                                                            :key="index"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt[0]"
                                                            select-class="type-single search size-s"
                                                            :data-invalid="cnd.cnd.prpts[lang['val']].invalid"
                                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]"></select-box-single>
                                                    </template>

                                                    <template v-if="lang['key'] === 'select' && lang['val'] === 'rsrc'">
                                                        <select-box-single
                                                            :select-id="`cndSelectRsrc_${cndIdx}_${index}`"
                                                            :key="index"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt[0]"
                                                            select-class="type-single search size-s"
                                                            :data-invalid="cnd.cnd.prpts[lang['val']].invalid"
                                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value]"></select-box-single>
                                                    </template>

                                                    <!-- type 인 select. type 값에 templateTypeVal 변경해줘야 함. -->
                                                    <template v-if="lang['key'] === 'select' && lang['val'] === 'type'">
                                                        <select-box-single :select-id="`cndSelectType_${cndIdx}_${index}`"
                                                            :key="index"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt[0]"
                                                            select-class="type-single search size-s"
                                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                                            @onSelectChange="rule.cndVal[cndIdx].cnd.prpts[lang['val']].slt=[$event.value];reRender()"></select-box-single>
                                                    </template>

                                                    <!-- view 인 select. view 값에 따라 templateTypeVal 변경해줘야 함. -->
                                                    <template v-if="lang['key'] === 'select' && lang['val'] === 'view'">
                                                        <select-box-single :select-id="`cndSelectView_${cndIdx}_${index}`"
                                                            :key="index"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt[0]"
                                                            select-class="type-single search size-s"
                                                            place-holder="View"
                                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value];reRender()"></select-box-single>
                                                    </template>
                                                    <!-- svcGrp 인 select. view 값에 따라 templateTypeVal 변경해줘야 함. -->
                                                    <template v-if="lang['key'] === 'select' && lang['val'] === 'svcGrp'">
                                                        <select-box-single :select-id="`cndSelectSvg_${cndIdx}_${index}`"
                                                            :key="index"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt[0]"
                                                            :use-dynamic="true"
                                                            :dynamic-value="cnd.cnd.prpts.view.slt[0]"
                                                            select-class="type-single search size-s"
                                                            place-holder="Service Group"
                                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = [$event.value];reRender()"></select-box-single>
                                                    </template>

                                                    <!-- typeVal, svcGrp 아닌 multi-select. 그냥 표시해주면 됨. -->
                                                    <template v-if="lang['key'] === 'multi-select'
                                                                     && lang['val'] != 'typeVal'
                                                                     && lang['val'] != 'svcGrp'">
                                                        <select-box-multi :select-id="`cndMultiSelect_${cndIdx}_${index}`"
                                                            :key="index"
                                                            select-class="type-tagging size-s"
                                                            :use-labels="true"
                                                            :select-box-options="newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value;"></select-box-multi>
                                                    </template>

                                                    <!-- typeVal 인 multi-select. type 값에 따라 변경되어야 함. -->
                                                    <template v-if="lang['key'] === 'multi-select' && lang['val'] === 'typeVal'">
                                                        <!--{{newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit']}}
                                                        {{cnd.cnd.prpts.type.slt[0]}}-->
                                                        <select-box-multi :select-id="`cndMultiSelectTypeSvc_${cndIdx}_${index}`"
                                                            :key="index"
                                                            select-class="type-tagging size-s"
                                                            :use-labels="true"
                                                            :use-dynamic="true"
                                                            :dynamic-value="cnd.cnd.prpts.type.slt[0]"
                                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value;"></select-box-multi>
                                                    </template>

                                                    <!-- svcGrp 인 multi-select. view 값에 따라 변경되어야 함. -->
                                                    <template v-if="lang['key'] === 'multi-select' && lang['val'] === 'svcGrp'">
                                                        <select-box-multi :select-id="`cndMultiSelectSvg_${cndIdx}_${index}`"
                                                            :key="index"
                                                            select-class="type-tagging size-s"
                                                            :use-labels="true"
                                                            :use-dynamic="true"
                                                            :dynamic-value="cnd.cnd.prpts.view.slt[0]"
                                                            :select-box-options="groupType(newTmplt[cndIdx].basicFormation.cnd[lang['val']]['unit'])"
                                                            :select-box-value="cnd.cnd.prpts[lang['val']].slt"
                                                            @onSelectChange="cnd.cnd.prpts[lang['val']].slt = $event.value"></select-box-multi>
                                                    </template>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <button type="button" class="buttons-add" @click="addCondition('and')">{{ $t('POLICY.BUTTON.ADD_RULE')}}<!--측정 기준 추가--></button>

                                <!-- 작업 설정 Area : Start -->
                                <div class="select-action" v-for="(actn, actnIdx) of rule.actnVal" :key="actn.actnId+actnIdx">
                                    <div class="actions" v-if="actn.actnId !== null || actnIdx > 0 || rule.actnVal.length > 1">
                                        <button type="button" class="buttons-icon" data-type="ghost" data-icon="delete" data-size="s" title="삭제" @click="deleteAction(actnIdx)">{{$t('COMMON.BUTTON.CAMEL.DELETE')}}</button>
                                    </div>
                                    <div class="action">
                                        <select-box-single :select-id="`actnSelect_${actnIdx}`"
                                            :key="actnIdx"
                                            :select-box-value="actn.actnId"
                                            select-class="type-single size-s"
                                            :select-box-options="selectableActionList"
                                            @onSelectChange="invalidActionValue = false; selectAction(actnIdx, $event.value)"
                                            :data-invalid="invalidActionValue"
                                            :use-translate="true">
                                        </select-box-single>
                                    </div>
                                    <template v-for="(actnTmplt, index) of actionTemplateList">
                                    <div class="conditions" v-if="actnTmplt.actnId === actn.actnId && actnTmplt.trgtYn === constants.PARAM.SELECT.Y" :key="index">
                                        <select-box-multi :select-id="`actnMultiSelect_${actnIdx}_${index}`"
                                            select-class="type-tagging size-s"
                                            :use-labels="true"
                                            place-holder="POLICY.RULE.ACTION.SELECT_RECIPIENT"
                                            :select-box-options="getUserListOptions"
                                            :select-box-value="actn.trgt"
                                            :data-invalid="invalidActionEmailUser"
                                            @onSelectChange="invalidActionEmailUser = false; actn.trgt = $event.value"></select-box-multi>
                                    <p class="invalid-message" v-if="invalidActionEmailUser">
                                            {{$t("POLICY.RULE.INVALID.RECEIVER")}}
                                        </p>
                                    </div>
                                    </template>
                                </div>
                                <!-- 작업 설정 Area : End -->

                                <button type="button" class="buttons-add" @click="addAction()">{{ $t(`POLICY.BUTTON.ADD_TASK`) }}<!--작업 추가--></button>

                                <p>
                                    <input type="checkbox" ref="eleActnExeYn" id="eleActnExeYn" name="eleActnExeYn" class="checkbox"
                                           :checked="rule.actnExeYn == null || rule.actnExeYn === constants.PARAM.SELECT.Y ? true : null" @click="setActionExecutionYN()">
                                    <label for="eleActnExeYn">{{$t('POLICY.RULE.ACTION_EXECUTION')}}<!--다음 작업을 검사후 바로 실행합니다.--></label>
                                </p>
                            </div>
                        </div>

                        <!--개선방법-->
                        <!--EN-->
                        <div class="form-item">
                            <label for="" class="textfield-with">{{ $t('POLICY.LABEL.REMEDIATION')}} in English<!--개선방법--></label>
                            <textarea class="textarea" :placeholder="$t('POLICY.RULE.INVALID.REMEDIATION')" v-model="rule.enRuleRemd"></textarea>
                        </div>

                        <!--FOR KO-->
                        <div class="form-item">
                            <label for="" class="textfield-with">{{ $t('POLICY.LABEL.REMEDIATION')}} in Korean<!--개선방법--></label>
                            <textarea  class="textarea" :placeholder="$t('POLICY.RULE.INVALID.REMEDIATION')" v-model="rule.koRuleRemd"></textarea>
                        </div>

                        <!--FOR ZH-->
                        <div class="form-item">
                            <label for="" class="textfield-with">{{ $t('POLICY.LABEL.REMEDIATION')}} in China<!--개선방법--></label>
                            <textarea  class="textarea" :placeholder="$t('POLICY.RULE.INVALID.REMEDIATION')" v-model="rule.zhRuleRemd"></textarea>
                        </div>
                    </div>
                </fieldset>

            </div>
        </div>
        <div class="layout-popup-footer">
            <div class="left-view">
                <button type="button" class="buttons" data-type="line" data-size="l" @click="closePopup()">{{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}<!--취소--></button>
            </div>
            <div class="right-view">
                <button v-if="curStep === 1"
                    type="button"
                    class="buttons"
                    data-type="key"
                    data-size="l"
                    :disabled="!isEdit && !isCopy && (invalidRuleTitle || invalidRuleCtgLabel)"
                    @click="goNext()">{{ $t('COMMON.BUTTON.CAMEL.NEXT')}}<!--다음--></button>
                <button v-if="curStep === 2"
                    type="button"
                    class="buttons"
                    data-size="l"
                    @click="curStep = curStep - 1">{{ $t('COMMON.BUTTON.CAMEL.PREV')}}<!--이전--></button>
                <button v-if="curStep === 2" type="button"
                    class="buttons"
                    data-type="key"
                    data-size="l"
                    :disabled="!isEdit && !isCopy && (invalidRuleTitle || invalidRuleCtgLabel)"
                @click="fnSaveRule(false)">{{ $t('COMMON.BUTTON.CAMEL.OK')}}<!--확인--></button>
            </div>
        </div>
    </div>
</template>
<script>
import { shiftLeft } from '@amcharts/amcharts4/.internal/core/utils/Array';

import { EventBus } from "../common/event-bus";

export default {
    name: 'systemAutoRulePopup',
    props: {
        rule: Object,               // Popup 에서 control 될 Rule 정보
        newTmplt: Array,            // 사용되고있는 Template의 정보 리스트
        categoryList: Array,        // 회사에 등록되어있는 Category Label 정보 리스트
        actionTemplateList: Array,  // action 정보 리스트
        userList: Array,            // 회사에 가입되어있는 사용자 리스트 정보(Email 수신자 추가시 필요)
        isEdit: Boolean,            // Edit 모드 활성화 플래그
        isCopy: Boolean,            // Copy 모드 활성화 플래그
        callLoading: Function,
        saveRule: Function,
        setActionList: Function,
        isFirstLoad:  Boolean
    },
    data: function() {
        return {
            curStep: 1                        // Popup Step
            , msrFltrList: []                   // Condition Measure Filter List
            , msrDynamicVal: ''                 // Measure 별 동적 필터 조건 값
            , prodDynamicVal: ''                // Product 별 동적 필터 조건 값
            , prodDynamicInvalid: false         // Product 별 동적 필터 Validation check flag
            , cndDynamicInvalid: false         // Product 별 동적 필터 Validation check flag
            , actionListBySelectedTemplate: []  // Condition 으로 선택할 수 있는 Action List
            , templateTypeValList: []           // type 에 따라 변경되는 typeVal 의 unit 저장

            // 유효성 검사 값
            , invalidRuleTitle: true           // Rule Title 에 대한 invalid 구분
            , invalidRuleTitleMsg : ""          // Rule Title Invalid Message
            , invalidRuleDesc: false            // Rule Desc 에 대한 invalid 구분
            , invalidRuleCtgLabel: true        // Rule Category 에 대한 invalid 구분
            , invalidRuleConditionMsg: ""       // Rule Condition Invalid Message
            , invalidActionValue: false         // Action Value 에 대한 invalid 구분
            , invalidActionEmailUser: false     // Action Email 선택시 유저선택 에 대한 invalid 구분
            , svrtyOptions:[
                    {key: '1', val: 'LABEL.SVRTY.1', dataIcon: 'low'},
                    {key: '2', val: 'LABEL.SVRTY.2', dataIcon: 'medium'},
                    {key: '3', val: 'LABEL.SVRTY.3', dataIcon: 'high'},
                    {key: '4', val: 'LABEL.SVRTY.4', dataIcon: 'critical'}
                ]                               // 심각도 필터 옵션
            , conjunctionOptions:[
                    {key: 'and', val: 'COMMON.CONJUNCTION.and'},
                    {key: 'or', val: 'COMMON.CONJUNCTION.or'}
                ]// AND || OR 조건 필터 옵션
            , reRenderKey: 1
        }
    },
    mounted: function() {
        this.initView();
        this.checkInputFields();
    },
    watch: {
        rule: function(){
            let self = this

            _.find(this.rule.actnVal, function(o){
                o.actnId === self.constants.PARAM.SELECT.NULL ? o.actnId = self.constants.PARAM.SELECT.NONE: false
            })

        }
    },
    computed: {
        curLang: function() {
            return this.$i18n.locale;
        },
        selectableActionList: function() {
            let selectableActionList = [];

            selectableActionList.push({key: '', val: 'POLICY.RULE.ACTION.NONE'})

            if(this.rule.actnVal.length === 1)
            {
                selectableActionList.push({
                    key: this.constants.PARAM.SELECT.NONE,
                    val: 'POLICY.RULE.POPUP.SELECT_NONE'
                })
            }

            for(let actionTemplate of this.actionListBySelectedTemplate) {
                // 액션 자유롭게 선택 후 저장 시 Validation 체크 하도록 로직 수정 / 2019. 11.25 by sungho.hong
                // let isNotExist = true;
                // for(let action of this.rule.actnVal) {
                //     if(action.actnId !== null && action.actnId === actionTemplate.actnId) {
                //         isNotExist = false;
                //         break;
                //     }
                // }
                //if(isNotExist) {
                    selectableActionList.push({key: actionTemplate.actnId, val: 'POLICY.RULE.ACTION.' + actionTemplate.actnId});
                //}
            }
            return selectableActionList;
        },
        prodFltrList: function() {
            return Object.keys(_.groupBy(this.templateList, 'prod')).sort();
        },
        templateList: function() {
            return this.$store.state.templateList;
        },
        getprodFlterOptions: function() {
            let options = []
            if (this.templateList && this.prodFltrList) {
                self = this;
                this.prodFltrList.forEach((product)=>{
                    const template = _.find(self.templateList, (tmpl) => {
                        return (tmpl.prod.toLowerCase() === product.toLocaleLowerCase());
                    });
                    let item = {};
                    item.key = product;
                    item.val  = `PRODUCT.${product}`;
                    switch (template.vendor.toLowerCase()) {
                        case "aws":
                            item.dataIcon = 'aws';
                            break;
                        case "azu":
                            item.dataIcon = 'azure';
                            break;
                        case "gcp":
                            item.dataIcon = 'gcp';
                            break;
                        case "alibaba":
                            item.dataIcon = 'alibaba';
                            break;
                    }
                    options.push(item);
                })
            }
            return options;
        },
        getCtgFilterOptions: function() {
            let ctgFilter = []
            this.categoryList.forEach(function(r){
                    ctgFilter.push({key:r.ctgId, val:r.ctgLabel})
            })
            return ctgFilter;
        },
        getUserListOptions: function() {
            let userOptions = []
            this.userList.forEach(function(u){
                userOptions.push({key:u.userId, val:`${u.userNm}(${u.userEmail})`})
            })

            return userOptions
        },
        msrFilterOptions: {
            get: function(){
                return _.groupBy(_.unionBy(this.templateList, 'msr'), 'prod')
            },
            set: function(value) {
                this.msrDynamicVal = ''
                this.prodDynamicVal = value
                this.prodDynamicInvalid = false
            }
        },
        cndFilterOptions: {
            get: function(){
                return _.groupBy(this.templateList, 'prod')
            },
            set: function(value) {
                this.msrDynamicVal = ''
                this.prodDynamicVal = value
                this.prodDynamicInvalid = false
            }
        },
        cndFilterMsrOptions: {
            get: function(){
                return _.groupBy(this.templateList, 'msr')
            },
            set: function(value) {
                //this.msrValue = null
                //this.msrDynamicVal = value
            }
        }
    },
    methods: {
        checkInputFields() {
            if (!this.isFirstLoad) {
                // checkRuleName
                this.isInvalidRuleTitle();
                // checkCategory
                this.isInvalidRuleCategoryLabel();
            }
        },
        initView: function() {
            var self = this;

            // magnificPopup close Event override
            $.magnificPopup.instance.close = function () {

                // Popup step 초기화
                self.curStep = 1;

                // Popup invalid 초기화
                self.resetInvalid();

                // magnificPopup 의 proto close call
                $.magnificPopup.proto.close.call(this);
            };
        },
        goNext: function() {
            this.rule.titl = this.rule.transTitl;
            this.rule.desc = this.rule.transDesc;
            this.rule.remd = this.rule.transRemd;
            if(this.isInvalidRuleTitle() || this.isInvalidRuleDesc() || this.isInvalidRuleCategoryLabel()) {
                return;
            }

            this.curStep++;
        },

        addCondition: function (cjt) {
            // Condition 추가
            // cjt : 추가할 Condition Conjunction
            if(this.isInvalidTemplate()) return;


            this.rule.cndVal.push({
                'tmpltId': 'new',
                'cjt': cjt,
                'cnd': {
                    'cjt': null
                }
            });

            // 템플릿 선택 필터값 초기화
            this.prodDynamicVal = ''
            this.prodDynamicInvalid = false
            this.cndDynamicInvalid = false

        },
        delCnd: function (cndIdx) {
            // Condition 삭제
            // cndIdx : 삭제할 Condition Index

            this.prodDynamicInvalid = false

            this.rule.cndVal.splice(cndIdx, 1);
            this.newTmplt.splice(cndIdx, 1);

            // Condition 삭제했을 때도 ActionList 다시 세팅
            this.setActionList(this.newTmplt);
            if(this.rule.cndVal.length === 0) {
                this.rule.cndVal.push({
                    'tmpltId': 'new',
                    'cjt': null,
                    'cnd': {
                        'cjt': null
                    }
                });
            } else {
                this.rule.cndVal[0].cjt = null;
            }
        },
        // Template 선택
        selectTemplate: function (event) {

            var length = this.rule.cndVal.length;
            var idx = length - 1;
            //var selectedIdx = event.target.selectedIndex -1; // Option 목록에 빈 값이 들어가있어서 Index 가 +1 되니 찾을 땐 -1을 해줌

            let selectedTemplate = _.cloneDeep(_.find(this.templateList, {'tmpltId': event.value})) // cloneDeep 이 없으면 동일한 template 두 번 선택했을 때 이미 object 로 바껴있는 애라고 에러남

            // template 세팅 및 저장 obj 에 template ID 세팅 및 조건 배열 초기화
            this.newTmplt.push(selectedTemplate);
            // Action 세팅 및 저장할 obj 에 action ID 세팅
            this.setActionList(this.newTmplt);

            // Condition 에 Template ID 세팅
            this.rule.cndVal[idx].tmpltId = selectedTemplate.tmpltId;

            // 새 Sub condition 배열, 객체 세팅
            this.rule.cndVal[idx].cnd = {
                'cjt': null,
                'prpts': {}
            };

            // cond 에 properties 세팅
            for(var key in selectedTemplate.basicFormation.cnd) {
                if(key.toLowerCase() !== 'cjt') {
                    this.rule.cndVal[idx].cnd.prpts[key] = {
                        'val': selectedTemplate.basicFormation.cnd[key].val,
                        'slt': selectedTemplate.basicFormation.cnd[key].slt
                    };
                }
            }
        },
        // Action 선택
        selectAction(actnIdx, actnId) {
            var obj = this.rule.actnVal[actnIdx];
            // actnId 세팅
            obj.actnId = actnId;
            // 선택한 Action 이 trgtYN Y 이면 trgt array 넣어줌. 근데 지금 Target 있는 게 Email 밖에 없다고 한다
            for(var actnTmplt of this.actionTemplateList) {
                if(actnTmplt.actnId === actnId && actnTmplt.trgtYn === this.constants.PARAM.SELECT.Y) {
                    obj.trgt = [];
                }
            }
        },
        // Action 추가
        addAction() {
            this.rule.actnVal.push({
                "actnId": null
            });
        },
        // Action 삭제
        deleteAction: function(actnIdx) {
            this.rule.actnVal.splice(actnIdx, 1);
            //this.rule.actnVal = _.reject(this.rule.actnVal, {actnId: actnId})
            this.$nextTick(function() {
                if (this.rule.actnVal.length === 0) {
                    this.addAction()
                }
            })
        },
        fnSaveRule: function (isNewForm) {
            this.rule.autoExeYn='Y';
            this.callLoading(true);
            if(isNewForm) {
                let self = this
                // isValid 로 유효성 체크
                if(!(this.isInvalidTemplate() || this.isInvalidCondition() || this.isInvalidActionValue())) {
                    this.callLoading(true);
                    // Action 추가 후 항목 선택 안한 array 제거
                    this.rule.actnVal = _.reject(this.rule.actnVal,
                        function(o) {
                            return o.actnId === self.constants.PARAM.SELECT.NULL || o.actnId === self.constants.PARAM.SELECT.NONE
                        }
                    );
                    if (this.rule.actnVal.length === 0) {
                        this.addAction()
                        this.rule.actnExeYn = 'N'
                    }
                    this.saveRule(this.rule);
                    this.closePopup();
                } else {
                    this.reRender();
                }
            } else {
                this.saveRule(this.rule);
                this.closePopup();
            }
        },

        // Rule Title 유효성 검사
        isInvalidRuleTitle() {
            if(this.Common.isEmptyText(this.rule.enRuleTitle) || this.Common.isEmptyText(this.rule.koRuleTitle)||this.Common.isEmptyText(this.rule.zhRuleTitle)){
                this.invalidRuleTitle = true;
                this.invalidRuleTitleMsg = this.$t('POLICY.RULE.INVALID.TITLE');

            }else{
                this.invalidRuleTitle = false;
            }
            return this.invalidRuleTitle;
        },
        // Rule Desc 유효성 검사
        isInvalidRuleDesc() {
            // this.Common.isEmptyText(this.rule.desc)
            this.invalidRuleDesc =
            ((this.rule.enRuleDesc && this.rule.enRuleDesc > 4000)&&
            (this.rule.koRuleDesc && this.rule.koRuleDesc > 4000)&&
            (this.rule.zhRuleDesc && this.rule.zhRuleDesc > 4000) )
            ? true : false;
            return this.invalidRuleDesc;
        },
        // Rule Category Label 선택 검사
        // 선택한 카테고리([]) 개수 검사해야함
        isInvalidRuleCategoryLabel() {
            this.invalidRuleCtgLabel = this.rule.ctgLabel.length < 1 ? true : false;

            this.invalidRuleCtgLabel ? $('.go-vendor.rule-select-ctg.ui.dropdown').attr("data-invalid", true) : $('.go-vendor.rule-select-ctg.ui.dropdown').removeAttr("data-invalid")

            return this.invalidRuleCtgLabel;
        },
        // Condition 선택 유효성 검사, 프로덕 > 측정 조건 > 조건 선택 했는지 검사
        isInvalidTemplate() {
            var i = this.rule.cndVal.length - 1;
            var isInvalid = false
            // 마지막 rule.cndVal 의 tmpltId 가 null 이면 규칙 추가 해놓고 조건 선택 안 함..
            if(this.rule.cndVal[i].tmpltId === 'new') {

                this.prodDynamicInvalid = this.prodDynamicVal === '' || this.prodDynamicVal === -1 ? true : false
                this.cndDynamicInvalid = true
                isInvalid = true
            }
            return isInvalid;
        },
        // 전체 Condition 의 value 검사
        isInvalidCondition() {
            var isInvalid = false;

            for (let cond of this.rule.cndVal){
                let keySet = Object.keys(cond.cnd.prpts)
                for(let key of keySet){
                    if(key === this.constants.TEMPLATE_PROPERTIES.CURRENCY ||
                        key === this.constants.TEMPLATE_PROPERTIES.TIME ||
                        key === this.constants.TEMPLATE_PROPERTIES.NUMBER ||
                        key === this.constants.TEMPLATE_PROPERTIES.PERCENT){
                        if(this.Common.isEmptyText(cond.cnd.prpts[key].val) || this.Common.validNumber(cond.cnd.prpts[key].val)){
                            cond.cnd.prpts[key].invalid = true
                            isInvalid = true
                        }
                    }
                    else if (key === this.constants.TEMPLATE_PROPERTIES.AWS_CONFIG ||
                        key === this.constants.TEMPLATE_PROPERTIES.TAG){
                        if(cond.cnd.prpts[key].slt.length < 1){
                            cond.cnd.prpts[key].invalid = true
                            isInvalid = true
                        }
                    }
                }
            }

            return isInvalid;
        },
        // Target 이 있는 Action 에 대해서 Value 값 입력 유효성 검사
        isInvalidActionValue() {

            for(var actn of this.rule.actnVal) {
                for(var actnTmplt of this.actionTemplateList) {
                    if(actn.actnId === actnTmplt.actnId) {
                        if(actnTmplt.trgtYn === this.constants.PARAM.SELECT.Y && actn.trgt.length < 1) {
                            this.invalidActionEmailUser = true;
                        } else {
                            this.invalidActionEmailUser = false;
                        }
                        break;
                    }
                }

                if(_.filter(this.rule.actnVal, { actnId : actn.actnId}).length > 1) {
                    this.invalidActionValue = true
                }

                if(this.invalidActionValue || this.invalidActionEmailUser) {
                    break;
                }
            }
            return this.invalidActionValue || this.invalidActionEmailUser;
        },
        // Popup 의 invalid 초기화(false)
        resetInvalid() {
            this.invalidRuleTitle = false;
            this.invalidRuleDesc = false;
            this.invalidRuleCtgLabel = false;
            //$('.go-vendor.rule-select-ctg.ui.dropdown').removeAttr("data-invalid") // 나중에 멀티셀렉트 컴포넌트화 시켜서 다 옮겨버린다..
        },
        // close Popup
        closePopup() {
            $.magnificPopup.close();
            // EventBus.$emit('closeRulePopup')
        },
        setActionExecutionYN() {
            //this.$refs.eleActnExeYn.checked = this.$refs.eleActnExeYn.checked ? true : null
            this.rule.actnExeYn = this.$refs.eleActnExeYn.checked ? this.constants.PARAM.SELECT.Y : 'N';

        },
        groupType: function(item){
            return _.groupBy(_.unionBy(item, 'key'), 'upType')
        },
        reRender: function(){
            this.reRenderKey++
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/bestpractice/systemAutoRulePopup.vue